var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81511 19V5H12.3401C13.4234 5 14.4234 5.33333 15.3401 6C16.2568 6.66667 16.7151 7.59167 16.7151 8.775C16.7151 9.625 16.5234 10.2792 16.1401 10.7375C15.7568 11.1958 15.3984 11.525 15.0651 11.725C15.4818 11.9083 15.9443 12.25 16.4526 12.75C16.9609 13.25 17.2151 14 17.2151 15C17.2151 16.4833 16.6734 17.5208 15.5901 18.1125C14.5068 18.7042 13.4901 19 12.5401 19H6.81511ZM9.84011 16.2H12.4401C13.2401 16.2 13.7276 15.9958 13.9026 15.5875C14.0776 15.1792 14.1651 14.8833 14.1651 14.7C14.1651 14.5167 14.0776 14.2208 13.9026 13.8125C13.7276 13.4042 13.2151 13.2 12.3651 13.2H9.84011V16.2ZM9.84011 10.5H12.1651C12.7151 10.5 13.1151 10.3583 13.3651 10.075C13.6151 9.79167 13.7401 9.475 13.7401 9.125C13.7401 8.725 13.5984 8.4 13.3151 8.15C13.0318 7.9 12.6651 7.775 12.2151 7.775H9.84011V10.5Z",
    fill: "#343F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorBold);
export default __webpack_public_path__ + "static/media/editor-bold.e6271b771482c14c3f46d7535692ae0d.svg";
export { ForwardRef as ReactComponent };